var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _propertyTypes$COMMER, _buyerTypes$FIRST_TIM, _propertyTypes$RESIDE, _sdltBands, _taxNames;

var additionalPropertySurcharge = 5;
var additionalNonUKSurcharge = 2;
var additionalScotlandPropertySurcharge = 6;
var percent = String.fromCharCode(37); // Countries object

var countries = {
  ENGLAND: 'england',
  SCOTLAND: 'scotland',
  WALES: 'wales',
  IRELAND: 'ireland'
}; // Ireland initial slab rates

var mortageCountryScheme = [{
  value: 'all',
  label: 'Choose Council'
}, {
  value: '325000_Carlow',
  label: 'Carlow County Council'
}, {
  value: '325000_Cavan',
  label: 'Cavan County Council'
}, {
  value: '325000_Clare',
  label: 'Clare County Council'
}, {
  value: '475000_CorkCity',
  data_apt: "500000",
  label: 'Cork City Council'
}, {
  value: '425000_CorkContry',
  label: 'Cork County Council'
}, {
  value: '325000_Donegal',
  label: 'Donegal County Council'
}, {
  value: '475000_DublinCity',
  data_apt: "500000",
  label: 'Dublin City Council'
}, {
  value: '475000_Dublin_county',
  data_apt: "500000",
  label: 'Dublin South County Council'
}, {
  value: '475000_Dun',
  data_apt: "500000",
  label: 'Dun Laoghaire-Rathdown County Council'
}, {
  value: '475000_Fingal',
  data_apt: "500000",
  label: 'Fingal County Council'
}, {
  value: '425000_GalwayCity',
  data_apt: "450000",
  label: 'Galway City Council'
}, {
  value: '375000_Galway_country',
  label: 'Galway County Council'
}, {
  value: '325000_Kerry',
  label: 'Kerry County Council'
}, {
  value: '425000_Kildare',
  label: 'Kildare County Council'
}, {
  value: '375000_Kilkenny',
  label: 'Kilkenny County Council'
}, {
  value: '350000_Laois',
  label: 'Laois County Council'
}, {
  value: '325000_Leitrim',
  label: 'Leitrim County Council'
}, {
  value: '375000_Limerick',
  data_apt: "450000",
  label: 'Limerick City and County Council'
}, {
  value: '325000_Longford',
  label: 'Longford County Council'
}, {
  value: '375000_Louth',
  label: 'Louth County Council'
}, {
  value: '325000_Mayo',
  label: 'Mayo County Council'
}, {
  value: '375000_Meath',
  label: 'Meath County Council'
}, {
  value: '325000_Monaghan',
  label: 'Monaghan County Council'
}, {
  value: '325000_Offaly',
  label: 'Offaly County Council'
}, {
  value: '325000_Roscommon',
  label: 'Roscommon County Council'
}, {
  value: '325000_Sligo',
  label: 'Sligo County Council'
}, {
  value: '325000_Tipperary',
  label: 'Tipperary County Council'
}, {
  value: '350000_Waterford',
  data_apt: "450000",
  label: 'Waterford City and County Council'
}, {
  value: '375000_Westmeath',
  data_apt: "450000",
  label: 'Westmeath County Council'
}, {
  value: '325000_Wexford',
  label: 'Wexford County Council'
}, {
  value: '475000_Wicklow',
  label: 'Wicklow County Council'
}]; // Ireland initial slab rates

var mortagePropertyType = [{
  value: 'all',
  label: 'Choose Type'
}, {
  value: 'house',
  label: 'House'
}, {
  value: 'apartment',
  label: 'Apartment'
}]; // Property Type object

var propertyTypes = {
  COMMERCIAL: 'commercial',
  RESIDENTIAL: 'residential'
}; // Buyer Type object

var buyerTypes = {
  FIRST_TIME: 'first',
  MOVING_HOUSE: 'home',
  INVESTOR: 'investor',
  OVERSEAS: 'overseas'
}; // Ireland initial slab rates

var ireland = [{
  upto: 1000000,
  rate: 1
}, {
  upto: 'end',
  rate: 2
}]; // Scotland initial slab rates

var scotland = [{
  upto: 250000,
  rate: 2,
  additionalScotlandPropertySurcharge: additionalScotlandPropertySurcharge
}, {
  upto: 325000,
  rate: 5,
  additionalScotlandPropertySurcharge: additionalScotlandPropertySurcharge
}, {
  upto: 750000,
  rate: 10,
  additionalScotlandPropertySurcharge: additionalScotlandPropertySurcharge
}, {
  upto: 'end',
  rate: 12,
  additionalScotlandPropertySurcharge: additionalScotlandPropertySurcharge
}];
var sdltBands = (_sdltBands = {}, _defineProperty(_sdltBands, propertyTypes.COMMERCIAL, (_propertyTypes$COMMER = {}, _defineProperty(_propertyTypes$COMMER, countries.ENGLAND, [{
  upto: 150000,
  rate: 0
}, {
  upto: 250000,
  rate: 2
}, {
  upto: 'end',
  rate: 5
}]), _defineProperty(_propertyTypes$COMMER, countries.WALES, [{
  upto: 150000,
  rate: 0
}, {
  upto: 250000,
  rate: 1
}, {
  upto: 1000000,
  rate: 5
}, {
  upto: 'end',
  rate: 6
}]), _defineProperty(_propertyTypes$COMMER, countries.SCOTLAND, [{
  upto: 150000,
  rate: 0
}, {
  upto: 250000,
  rate: 1
}, {
  upto: 'end',
  rate: 5
}]), _defineProperty(_propertyTypes$COMMER, "ireland", ireland), _propertyTypes$COMMER)), _defineProperty(_sdltBands, propertyTypes.RESIDENTIAL, (_propertyTypes$RESIDE = {}, _defineProperty(_propertyTypes$RESIDE, buyerTypes.FIRST_TIME, (_buyerTypes$FIRST_TIM = {}, _defineProperty(_buyerTypes$FIRST_TIM, countries.ENGLAND, {
  thresholds: [{
    upto: 300000,
    rate: 0
  }, {
    upto: 500000,
    rate: 5
  }, {
    upto: 625000,
    rate: 5
  }],
  limit: 500000
}), _defineProperty(_buyerTypes$FIRST_TIM, countries.SCOTLAND, {
  thresholds: [{
    upto: 175000,
    rate: 0,
    additionalScotlandPropertySurcharge: additionalScotlandPropertySurcharge
  }].concat(scotland),
  limit: -1
}), _buyerTypes$FIRST_TIM)), _defineProperty(_propertyTypes$RESIDE, buyerTypes.OVERSEAS, _defineProperty({}, countries.ENGLAND, {
  thresholds: [{
    upto: 250000,
    rate: 2
  }, {
    upto: 925000,
    rate: 7
  }, {
    upto: 1500000,
    rate: 12
  }, {
    upto: 'end',
    rate: 14
  }],
  limit: -1
})), _defineProperty(_propertyTypes$RESIDE, countries.ENGLAND, [{
  upto: 125000,
  rate: 0,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 250000,
  rate: 2,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 925000,
  rate: 5,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 1500000,
  rate: 10,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 'end',
  rate: 12,
  additionalPropertySurcharge: additionalPropertySurcharge
}]), _defineProperty(_propertyTypes$RESIDE, countries.WALES, [{
  upto: 180000,
  rate: 0,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 250000,
  rate: 3.5,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 400000,
  rate: 5,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 750000,
  rate: 7.5,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 1500000,
  rate: 10,
  additionalPropertySurcharge: additionalPropertySurcharge
}, {
  upto: 'end',
  rate: 12,
  additionalPropertySurcharge: additionalPropertySurcharge
}]), _defineProperty(_propertyTypes$RESIDE, countries.SCOTLAND, [{
  upto: 145000,
  rate: 0,
  additionalScotlandPropertySurcharge: additionalScotlandPropertySurcharge
}].concat(scotland)), _defineProperty(_propertyTypes$RESIDE, "ireland", ireland), _propertyTypes$RESIDE)), _sdltBands);
var englandFirstTimeLimit = sdltBands[propertyTypes.RESIDENTIAL][buyerTypes.FIRST_TIME][countries.ENGLAND].limit;
var comments = {
  firstTimeWales: 'there is no separate first time buyer exemption in Wales',
  under40kUKInvestor: 'all transactions below 40k in UK are exempt from ',
  UKInvestor: "".concat(additionalPropertySurcharge + percent, " surcharge is applied"),
  firstTimeEnglandOverLimit: "properties over \xA3".concat(englandFirstTimeLimit, " do not attract first time buyer relief"),
  EMPTY: ''
};
var taxNames = (_taxNames = {}, _defineProperty(_taxNames, countries.ENGLAND, {
  long: 'stamp duty land tax',
  short: 'SDLT'
}), _defineProperty(_taxNames, countries.IRELAND, {
  long: 'stamp duty',
  short: 'stamp duty'
}), _defineProperty(_taxNames, countries.SCOTLAND, {
  long: 'land and buildings tax',
  short: 'LBTT'
}), _defineProperty(_taxNames, countries.WALES, {
  long: 'land transaction tax',
  short: 'LTT'
}), _taxNames);
var config = {
  sdltBands: sdltBands,
  countries: countries,
  propertyTypes: propertyTypes,
  buyerTypes: buyerTypes,
  comments: comments,
  englandFirstTimeLimit: englandFirstTimeLimit,
  taxNames: taxNames,
  mortageCountryScheme: mortageCountryScheme,
  mortagePropertyType: mortagePropertyType
};
module.exports = config;